export default "<ion-tabs  (ionTabsWillChange)=\"chatPage($event)\">\n</ion-tabs>";